<template>
  <article class="pa-4">
    <div class="d-flex align-center mb-4" style="gap: 8px">
      <h1>Reviews</h1>
      <v-spacer></v-spacer>
      <v-btn text outlined @click="showImportDialog = true"><v-icon left>mdi-import</v-icon> Import</v-btn>
      <v-btn color="primary" depressed @click="showCreateDialog = true"><v-icon left>mdi-plus</v-icon> Create</v-btn>
    </div>

    <v-chip-group v-model="tag" active-class="primary" mandatory @change="onFilterTag">
      <v-chip v-for="item in tags" :key="item" :value="item" class="text-capitalize" label>
        {{ item }}
      </v-chip>
    </v-chip-group>
    <v-card class="pa-0 mt-4">
      <v-data-table
        :loading="table.loading"
        :headers="table.headers"
        :items="table.items"
        :items-per-page="table.pagination.limit"
        :page.sync="table.pagination.page"
        no-data-text="There are no templates"
        item-key="_id"
        class="mb-4"
        hide-default-footer
      >
        <template v-slot:[`item.image`]="{ item }">
          <img class="review-image" :src="parseImage(item)" :alt="item.customerName" @click="onEdit(item)" />
        </template>
        <template v-slot:[`item.rating`]="{ item }"> {{ item.rating }}/5 </template>
        <template v-slot:[`item.productType`]="{ item }">
          <v-chip v-if="item.productType" color="primary" label small>{{ item.productType }}</v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex">
            <v-btn color="primary" @click="onEdit(item)" icon>
              <v-icon> mdi-table-edit</v-icon>
            </v-btn>
            <v-btn color="error" @click="onDelete(item)" icon>
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <div class="d-flex align-center">
      <!-- <v-btn v-if="table.items.length" color="error" @click="onDeleteAll" depressed>
        <v-icon left>mdi-trash-can-outline</v-icon> Delele all
      </v-btn> -->
      <v-spacer></v-spacer>
      <v-pagination
        :length="table.pagination.length"
        v-model="table.pagination.page"
        :total-visible="10"
        @input="getData"
      ></v-pagination>
    </div>
    <v-dialog v-model="showImportDialog" :width="600">
      <ImportDialog v-if="showImportDialog" @close="onCloseDialog" />
    </v-dialog>
    <v-dialog v-model="showCreateDialog" :width="700">
      <CreateDialog v-if="showCreateDialog" @close="onCloseDialog" />
    </v-dialog>
    <v-dialog v-model="showEditDialog" :width="700">
      <EditDialog v-if="showEditDialog" :reviewTemplate="table.selected" @close="onCloseDialog" />
    </v-dialog>
    <v-dialog v-model="showDeleteDialog" :width="500">
      <DeleteDialog
        v-if="showDeleteDialog"
        :reviewTemplate="table.selected"
        :isAll="isDeleteAll"
        @close="onCloseDialog"
      />
    </v-dialog>
  </article>
</template>

<script>
import ImportDialog from './components/import-dialog'
import EditDialog from './components/edit-dialog'
import CreateDialog from './components/create-dialog'
import DeleteDialog from './components/delete-dialog'
import imageHelpers from '@/helpers/image'
import ApiService from '@/common/api.service'

export default {
  components: {
    ImportDialog,
    EditDialog,
    DeleteDialog,
    CreateDialog,
  },
  data() {
    return {
      table: {
        loading: false,
        headers: [
          { text: 'Photo', value: 'image', sortable: false, align: 'center' },
          { text: 'Customer', value: 'customerName', sortable: false },
          { text: 'Review', value: 'review', sortable: false },
          { text: 'Rate', value: 'rating', sortable: false },
          // { text: 'Status', value: 'isPublished', sortable: false },
          { text: 'Actions', value: 'actions', sortable: false, align: 'center' },
        ],
        items: [],
        pagination: {
          limit: 10,
          length: 1,
          page: 1,
        },
        selected: null,
      },
      showImportDialog: false,
      showEditDialog: false,
      showCreateDialog: false,
      showDeleteDialog: false,
      isDeleteAll: false,
      tags: ['All'],
      tag: 'All',
    }
  },
  methods: {
    async getData() {
      try {
        this.table.loading = true
        const params = {
          page: this.table.pagination.page,
          limit: this.table.pagination.limit,
          tag: this.tag?.toLowerCase(),
        }
        if (this.tag === 'All') delete params.tag
        const { status, data } = await ApiService.get('/reviews/review-template/search', '', params)
        if (status === 200) {
          this.table.items =
            data?.reviews?.map((item) => ({
              ...item,
              images: item.images.filter((image) => !!image && image != '<Image Url>'),
            })) || []
          const count = (await ApiService.get('/reviews/review-template/count', '', params))?.data?.count
          this.table.pagination.length = Math.ceil(count / params.limit)
          this.getTags()
        }
      } catch (error) {
        console.log('🚀 ~ file: ReviewTemplates.vue:22 ~ getData ~ error:', error)
      } finally {
        this.table.loading = false
      }
    },
    async getTags() {
      try {
        const { status, data } = await ApiService.get('/reviews/review-template/tags')
        if (status === 200) {
          this.tags = data?.tags || []
          this.tags.unshift('All')
        }
      } catch (error) {
        console.log('🚀 ~ file: index.vue:150 ~ getTags ~ error:', error)
      }
    },
    onFilterTag() {
      this.table.pagination.page = 1
      this.table.pagination.length = 1
      this.getData()
    },
    onEdit(item) {
      this.table.selected = item
      this.showEditDialog = true
    },
    onDelete(item) {
      this.table.selected = item
      this.showDeleteDialog = true
    },
    onCloseDialog() {
      this.showEditDialog = false
      this.showCreateDialog = false
      this.showDeleteDialog = false
      this.showImportDialog = false
      this.table.selected = null
      this.isDeleteAll = false
      this.getData()
    },
    parseImage(review) {
      return review?.images?.length
        ? imageHelpers.url(review.images[0], { width: 320, height: 320 })
        : require('@/assets/images/no-image.png')
    },
    onDeleteAll() {
      this.isDeleteAll = true
      this.showDeleteDialog = true
    },
  },
  created() {
    this.getData()
  },
}
</script>
<style lang="scss" scoped>
.review-image {
  margin-top: 6px;
  width: 80px;
  height: 80px;
  border-radius: 6px;
}
</style>
